<template>
  <maintenance v-if="healthStore.backEndStatus === 'MAINTENANCE'" />
  <template v-else>
    <sidebar :class="{ 'mobile-nav': menuStore.isMenuOpen }" />
    <topbar :title="$route.meta?.title"
            @toggle-mobile-menu="menuStore.toggleMenu()" />

    <section class="content">
      <router-view />
      <p-toaster-wrapper :active-toasters="toasterStore.activeToasters"
                         @remove-toaster="toasterStore.removeToaster"/>
      <render-modal />
    </section>
  </template>
</template>

<script lang="ts" setup>
import { Maintenance } from '@pidz/shared/components'
import { useHealthStore, useToaster, useMenuStore } from '@pidz/stores';
import { useModalController } from '@pidz/utils';
import { h } from 'vue';
import Sidebar from './components/Sidebar/Sidebar.vue';
import Topbar from './components/Topbar.vue';

const menuStore = useMenuStore();

const modal = useModalController();
const toasterStore = useToaster();
const healthStore = useHealthStore();

// we steer away from render functions, but in this case it was justified:
// we need to be able to pass various props to custom modals such as :accept=""
const renderModal = () => {
  if (!modal.current.value) {
    return null;
  }
  return h(modal.current.value, modal.currentData.value);
};
</script>
<style lang="scss">
@import '@web/scss/variables.scss';
@import '@web/scss/app.scss';
@import '@web/scss/mobile.scss';

#app {
  display: grid;
  grid-template-areas:
    'sidebar topbar'
    'sidebar content';
  grid-template-columns: 230px 1fr;
  grid-template-rows: minmax(0px, auto) minmax(0px, 1fr);
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  width: 100%;
}

.sidebar {
  grid-area: sidebar;
}

.topbar {
  grid-area: topbar;
}

.content {
  grid-area: content;
  background-color: var(--pidz-blue-background);
}
</style>
